
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gbx/checkout",
      function () {
        return require("private-next-pages/gbx/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gbx/checkout"])
      });
    }
  